/**
 * What one screen hands to the next during sign-in (the email typed, the code
 * challenge, who paused or removed the account). Kept in sessionStorage so it
 * survives a reload and a full-page move from the axios instance, and never
 * holds a password.
 */
export type TSignInFlow = {
  email?: string;
  keepSignedIn?: boolean;
  challengeId?: string | null;
  codeSentTo?: string | null;
  /** Date.now() when the newest code was sent. */
  codeSentAt?: number | null;
  coachName?: string | null;
  isTeamMember?: boolean;
  /** A one-time ok message for the sign-in screen. */
  notice?: string | null;
};

const KEY = 'sx-signin';

export const readFlow = (): TSignInFlow => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as TSignInFlow) : {};
  } catch {
    return {};
  }
};

export const updateFlow = (changes: TSignInFlow): TSignInFlow => {
  const next = { ...readFlow(), ...changes };
  try {
    sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // A blocked store only means a reload starts the screen afresh.
  }
  return next;
};

export const clearFlow = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
};
